import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"

import "./Login.vue?vue&type=style&index=0&id=62627d90&scoped=true&lang=css"

import exportComponent from "/home/ppkd-dokumen-backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62627d90"]])

export default __exports__